"use strict";

export function initInScope ($scope) {
    $('#messageModal').modal('show');

    /*if (!sessionStorage.getItem('messageModal')) {
        $('#warningModal').modal('show');
    }

    $scope.find('.js-close-message-modal').on('click', function (ev) {
        sessionStorage.setItem('messageModal','closed');
    });*/
}
